import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
import { VISUAL_IMAGE, VISUAL_IMAGE_ALT } from '../data/offer';
const imagine = ['Imagine explaining the welding circuit with one clear, labeled visual.', 'Walking students through push vs. drag gun angles with real degrees.', 'Showing an undercut bead and a correct fillet weld side by side.', 'Reading a welding symbol and knowing exactly which weld goes on which side.', 'And connecting every technique to a sound, inspection-ready weld.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3gb8t9g0d7xup">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3l8s8oj8sugo8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="3l9k2boiu64bv">
          <div data-id="element-335" data-mp="eqai25cuvx7t">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#16191E] uppercase" data-id="element-336" data-mp="epr1aryxzevd">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#16191E] mb-1" data-id="element-337" data-mp="nr8pkxmi6mv5">Welding Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#E8590C] mb-5" data-id="element-338" data-mp="jrzxdx742x1p">
              Your Teaching Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3s44272s7xu2o">
              <p data-id="element-340" data-mp="3n8yhu8egsngp">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#16191E]" data-id="element-341" data-mp="4t5uc13d3tow">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="14nwvsvkx6s">
                <span className="font-semibold text-[#B8480A]" data-id="element-343" data-mp="l4tbrho2r6">WELDING INSTRUCTOR ATLAS</span> is
                built around illustrations, labeled diagrams, technique sequences, numbered breakdowns, ❌/✅
                comparisons, teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#F3F5F7] border border-[#D5DAE0] rounded-2xl p-6" data-id="element-344" data-mp="1cfcqjdudbpbw">
            <p className="text-sm font-bold text-[#B8480A] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1cd01kgq70epc">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m5flvkoypfde">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="oigt3l1e4rks">
                  <CheckCircle2 size={16} className="text-[#E8590C] shrink-0 mt-0.5" data-id="element-348" data-mp="thjqcjb4pti7" />
                  <span data-id="element-349" data-mp="yf1yw8l8i6po">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} src={VISUAL_IMAGE} alt={VISUAL_IMAGE_ALT} loading="lazy" className="w-full max-w-2xl h-auto mx-auto mt-12 rounded-2xl border border-[#D5DAE0] shadow-lg shadow-[#16191E]/10" data-id="element-350" data-mp="13ffxz14uy6bk" />

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#16191E] mt-14" data-id="element-351" data-mp="3uevribawkvyd">
          <span className="text-[#E8590C]" data-id="element-352" data-mp="3pjq1b0agwv4h">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#16191E] text-white px-2 box-decoration-clone" data-id="element-353" data-mp="3kl583ktmvbpj">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}